import { formatLibraryFolderSegment } from '../../lib/dateDisplay'
import type { BreadcrumbItem } from '../../types/breadcrumb'
import { ResponsiveBreadcrumbNav } from '../ResponsiveBreadcrumbNav'

function buildLibraryFolderPathBreadcrumbItems(
  selectedFolderPath: string,
  onNavigate: (path: string) => void,
): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [
    { label: '图库', onNavigate: () => onNavigate(''), title: '图库根目录' },
  ]
  const segments = selectedFolderPath.split('/').filter(Boolean)
  for (let i = 0; i < segments.length; i++) {
    const path = segments.slice(0, i + 1).join('/')
    const parentPath = i === 0 ? '' : segments.slice(0, i).join('/')
    const label = formatLibraryFolderSegment(segments[i]!, parentPath)
    const isLast = i === segments.length - 1
    items.push({
      label,
      title: path,
      onNavigate: !isLast ? () => onNavigate(path) : undefined,
    })
  }
  return items
}

/** 可点击面包屑：根目录 + 各级路径，末级为纯文本 */
export function LibraryFolderPathBreadcrumb({
  selectedFolderPath,
  onNavigate,
  dense,
}: {
  selectedFolderPath: string
  onNavigate: (path: string) => void
  /** 工具栏内略紧凑 */
  dense?: boolean
}) {
  const items = buildLibraryFolderPathBreadcrumbItems(selectedFolderPath, onNavigate)
  return (
    <ResponsiveBreadcrumbNav
      items={items}
      dense={dense}
      ariaLabel="文件夹路径"
      className="min-w-0 max-w-full text-ink-soft"
    />
  )
}
